import {useState} from "react";
import {CustomerInterface} from "../../interfaces/customer/CustomerInterface";
import {subscribeToProductWaitStatus} from "../../api/customer";

interface WaitStatusProps {
    customer: CustomerInterface
    code: string
    productName: string
    stockId?: string
}

export default function WaitStatus({customer, code, productName, stockId}: WaitStatusProps) {
    const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [showModal, setShowModal] = useState(false);

    const effectiveStockId = stockId || customer.stock_id;
    const email = customer.accounts?.[0]?.manager?.email || '';

    const handleSubscribe = async () => {
        setStatus('loading');
        try {
            const result = await subscribeToProductWaitStatus(customer, code, stockId);
            if ('is_error' in result && result.is_error) {
                setStatus('error');
                setErrorMessage(result.message);
            } else {
                setStatus('success');
                setShowModal(true);
            }
        } catch {
            setStatus('error');
            setErrorMessage('Не удалось оформить подписку. Попробуйте позже.');
        }
    };

    return (
        <>
            <div className="d-flex flex-column gap-2">
                {status !== 'success' && (
                    <div
                        className={'btn btn-secondary' + (status === 'loading' ? ' disabled' : '')}
                        onClick={status === 'loading' ? undefined : handleSubscribe}
                    >
                        <span>
                            <small>{status === 'loading' ? 'Отправка...' : 'Сообщить о поступлении'}</small>
                        </span>
                    </div>
                )}
                {status === 'success' && (
                    <div className="btn btn-secondary" style={{cursor: 'default'}}>
                        <span><small>Вы подписаны на поступление</small></span>
                    </div>
                )}
                {status === 'error' && (
                    <div className="text-danger small">{errorMessage}</div>
                )}
            </div>

            {showModal && (
                <div className="modal show" onClick={() => setShowModal(false)}>
                    <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
                        <div className="d-flex flex-column modal-content">
                            <div className="d-flex flex-column modal-box modal-header">
                                <button type="button" className="btn-close" aria-label="Закрыть"
                                        onClick={() => setShowModal(false)}></button>
                                <div className="fw-bold modal-title">Подписка оформлена</div>
                            </div>
                            <div className="d-flex flex-column modal-box modal-body">
                                <p className="mb-2">
                                    Вы подписались на уведомление о поступлении на склад <strong>{effectiveStockId}</strong> позиции <strong>{productName}</strong>.
                                </p>
                                {email && (
                                    <p className="mb-0">
                                        Уведомление придет на <strong>{email}</strong> после поступления товара на склад.
                                    </p>
                                )}
                            </div>
                            <div className="d-flex flex-column modal-box mt-3">
                                <button type="button" className="btn btn-primary modal-btn two"
                                        onClick={() => setShowModal(false)}>Закрыть</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
